import muiColors from "@mui/material/colors";
import { alpha, darken, lighten, } from "@mui/material/styles";
import "./paletteExtension.type";
const colors = Object.assign({}, muiColors);
export { colors, alpha, darken, lighten, };
export { ThemeProvider, EThemeName, EThemeSize, } from "./ThemeProvider";
export { useTheme, } from "./useTheme";
export { useMediaQuery, } from "@mui/material";
